const ALLOWED_TYPES = ['image/jpg', 'image/png', 'image/jpeg', 'image/bmp'];

export function getFileValidationErrors(file: File, types = ALLOWED_TYPES) {
  const errors = [];
  const isFileTypeValid = types.indexOf(file.type) !== -1;

  if (!isFileTypeValid) {
    errors.push('Загруженный файл имеет недопустимый формат.');
  }

  const fileSize = file.size / 1024 / 1024;

  if (fileSize > 10) {
    errors.push('Размер загруженного файла больше 10 Мб.');
  }

  return errors;
}
